import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Divider } from 'antd'
import Title from 'antd/es/typography/Title'
import BrowserBorder from '../../component/showcase/BrowserBorder'
import WorksPage from '../../component/showcase/WorksPage'
import ShowcasePreviewLayout from '../../component/showcase/ShowcasePreviewLayout'
import { getArtistProfilePublic } from '../../api/artists'
import { getArtworkCollectionPublic } from '../../api/artworkCollections'
import { URL_EDIT_COLLECTIONS_ID, URL_SHOWCASE_ARTWORK } from '../../const'
import { getEditUrl } from '../../component/Utils'

@connect((state) => ({
  //decorator, gives component access to the state
  siderWidth: state.style.siderWidth,
  id: state.user.info.id,
  userId: state.user.info.userId,
  artistId: state.user.info.artistId,
  email: state.user.info.email,
  artistName: state.user.info.artistName,
  role: state.user.info.role
}))
class Works extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      profile: null,
      items: []
    }
    this.artistId = this.props.artistId
  }

  async componentDidMount() {
    this.IS_MOUNT = true
    const profileRes = await getArtistProfilePublic(this.artistId)
    if (profileRes.status === 404) {
      return
    }
    this.setState({
      profile: profileRes.data
    })
    const collectionRes = await getArtworkCollectionPublic(this.artistId)
    if (collectionRes.status === 404) {
      return
    }
    this.setState({
      collection: collectionRes.data
    })
  }

  componentWillUnmount() {
    this.IS_MOUNT = false
  }

  render() {
    const getCollectionId = (props) => {
      const pathname = props.location?.pathname
      if (!pathname) return 'all'
      try {
        const paths = pathname.split('/')
        const name_id = paths[paths.length - 2]
        return name_id.split('_')[0]
      } catch (e) {
        return 'all'
      }
    }
    return (
      <ShowcasePreviewLayout {...this.props}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>
          <div>
            <Title style={{ marginBottom: 0 }}>Works</Title>
          </div>
          <div>
            <Button
              type='primary'
              onClick={() => {
                const id = getCollectionId(this.props)
                if (id === 'all') {
                  this.props.history.push({
                    pathname: URL_SHOWCASE_ARTWORK
                  })
                } else {
                  try {
                    const collection_id = this.state.collection.results[id - 1].id
                    this.props.history.push({
                      pathname: getEditUrl(URL_EDIT_COLLECTIONS_ID, collection_id)
                    })
                  } catch (e) {
                    this.props.history.push({
                      pathname: URL_SHOWCASE_ARTWORK
                    })
                  }
                }
              }}
              style={{ marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
              block
            >
              Update artworks
            </Button>
          </div>
        </div>
        <div>
          <i>
            To display in your showcase, choose some pieces of art from your collections and arrange them in the way you like.{' '}
            <a style={{ color: 'black', textDecoration: 'underline' }} href={'https://revart.co/sam/faqs/2.-Manage+The+Showcase'}>
              Learn More
            </a>
            .
          </i>
        </div>
        <Divider />
        <BrowserBorder {...this.props}>
          <WorksPage
            {...this.props}
            profile={this.state.profile}
            collection={this.state.collection}
            collectionId={getCollectionId(this.props)}
            items={this.state.items}
            onUpdateClick={this.onUpdateClick}
            onDeleteClick={this.onDeleteClick}
          />
        </BrowserBorder>
      </ShowcasePreviewLayout>
    )
  }
}

export default withRouter(Works)
